import { createTypes } from "./createTypes";

export default createTypes(
  "GET_ANNOUNCEMENTS",
  "GET_CURRENT_ANNOUNCEMENTS",
  "GET_PAST_ANNOUNCEMENTS"
);
